module.exports = __webpack_public_path__ + "img/1.9aa347f9.png";